class StartedWave {
    started:number;
    name?:string;
    porto:Wave;
    
    nextSubWaveIndexToStart:number;
    startedSubWaves:Array<StartedSubWave> = [];
    public onDone = new Signal<(wave:StartedWave)=>void>();
    
    constructor (wave:Wave) {
        this.porto = wave;
        this.name = wave.name;
        this.started = Game.millisecondsAbsolute;
        for (let i = 0; i < wave.subWaves.length; i++) {
            wave.subWaves[i].index = i;
        }
        this.nextSubWaveIndexToStart = 0;
        this.startNextSubWave();
    }
    
    public update(ms:number) {
        for (let sub of this.startedSubWaves) {
            sub.update(ms);
        }
    }
    
    private startNextSubWave() {
        let subProtos = this.porto.subWaves;
        let started = new StartedSubWave(subProtos[this.nextSubWaveIndexToStart]);
        PandaConsole.logDebug('wave: ' + this.name + ' started ind: ' + started.proto.index);
        this.startedSubWaves.push(started);
        this.nextSubWaveIndexToStart++;
        started.onDone.addListener(this.subFinshedHandler);
        if (this.nextSubWaveIndexToStart < subProtos.length) {
            let nextProto = subProtos[this.nextSubWaveIndexToStart];
            PandaConsole.logDebug('wave: ' + this.name + ' scheduled ind: ' + nextProto.index);
            setTimeout(() => {
                this.startNextSubWave();
            }, nextProto.timeFromPrevSec * 1000);
        }
    }
    
    private subFinshedHandler = (sub:StartedSubWave)=>{
        PandaConsole.logDebug('wave: ' + this.name + ' finished ind: ' + sub.proto.index);
        sub.onDone.removeListener(this.subFinshedHandler);
        let index = this.startedSubWaves.indexOf(sub);
        this.startedSubWaves.splice(index, 1);
        if (this.startedSubWaves.length == 0) {
            PandaConsole.logDebug('wave: ' + this.name + ' finished all');
            this.onDone.emit(this);
        }
    }
}
